module.exports = ".modal-backdrop\n{\n  background-color: rgba(0, 0, 0, 0.4) !important;\n}\n\n\n/* .modal_no_btn:hover{\n  background-color: #ee6560 !important;\n   color: white !important;\n}\n\n.modal_yes_btn:hover{\n background-color:#00a7ce !important;\n  color: white !important;\n} */\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/modal.component.css
// module id = ./src/app/shared/modal/modal.component.css
// module chunks = main